// api.js

import axios from 'axios';
import { roles } from './Constants';

const instance = axios.create({
  baseURL: process.env.REACT_APP_API_ROOT_URL_PREFIX, // Your API base URL
});

// Add a request interceptor
instance.interceptors.request.use(
  (config) => {
    // Add your custom headers here
    const stored = localStorage.getItem("Authorization");
    if (stored) {
      //normalize stored token, allow either raw JWT or barer
      let jwtToken = stored;
      if (stored.startsWith('Bearer ')) {
        jwtToken = stored.slice(7);
      }
      config.headers['Authorization'] = `Bearer ${jwtToken}`;
      
      config.headers['x-access-token'] = jwtToken;
    }
    if (roles.roleToken) {
      config.headers['x-role-token'] = roles.roleToken;
      console.log("[API] Added x-role-token header to request");
    }

    // You can add more headers or modify the existing ones as needed
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default instance;
